import { m8API } from 'services/production/m8';
import { PartnerProfileFormSubmitService } from 'types/services';
import { normalizePartnerProfileFormValues } from 'services/production/utils/normalizePartnerProfileFormValues';
import { validatePartnerProfileAvatarCroppedFile } from 'utils/validatePartnerProfileAvatarFile';

export const submitPartnerProfileForm: PartnerProfileFormSubmitService = async (
  params
) => {
  const m8PartnerInfo = normalizePartnerProfileFormValues(
    params
  ).toM8PartnerInfo();

  if (params.avatar) {
    const file = await params.avatar.readEditedFile();

    await validatePartnerProfileAvatarCroppedFile(file);

    await m8API.partner.setPartnerAvatar({
      image: file,
      mimeType: file.type,
    });
  }

  await m8API.partner.addPartnerInfo(m8PartnerInfo);
};
